<!-- @format -->
<template>
    <div class="activity-email-preview-popup" :style="cssProps">
        <div class="activity-email-preview-container">
            <div class="asset-preview-container">
                <div class="close-btn" @click="closePopup"><s3-close-svg /></div>
            </div>
            <div class="preview-content-container">
                <div v-if="activity.message.id" class="details">
                    <div class="from">
                        <span class="email-label">From:</span>
                        {{ activity.message.fromEmail || activity.campaign.fromEmail }}
                    </div>
                    <div class="subject">
                        <span class="email-label">Subject:</span>
                        {{ activity.message.subject }}
                    </div>
                    <div class="message-preview">
                        <email-preview :campaign-id="activity.campaign.id" :message-id="activity.message.id" />
                    </div>
                </div>
                <div v-else class="sales-note-details">
                    <div v-html="activity.content"></div>
                </div>
                <div v-if="group.isGroupable" class="activities">
                    <div
                        v-for="(groupActivity, index) in group.activities"
                        :key="groupActivity.id"
                        class="activity-engagement"
                        :style="{ 'z-index': group.activities.length - index }"
                    >
                        <div v-if="groupActivity.type === 'Click'" class="type click-type">
                            <img src="@/assets/images/SVG/small-click-icon.svg" alt="Click" />
                            <a :href="groupActivity.clickUrl" target="_blank">{{ groupActivity.clickUrl }}</a>
                        </div>
                        <div v-else-if="groupActivity.type === 'Open'" class="type open-type">
                            <img src="@/assets/images/SVG/small-mail-open-icon.svg" alt="Open" />
                            Opened email
                        </div>
                        <div class="date">{{ groupActivity.date | momentDate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const S3CloseSvg = () => import('@/components/svg/grid/s3-close-svg');
const EmailPreview = () => import('@/components/email/email-preview');

import BrandingMixin from '@/mixins/branding-mixin';
import DocumentBuilderMixin from '@/mixins/builder/document-builder-mixin';

export default {
    name: 'activity-email-preview-popup',

    components: {
        's3-close-svg': S3CloseSvg,
        'email-preview': EmailPreview,
    },

    mixins: [BrandingMixin, DocumentBuilderMixin],

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            pageWidth: 816,
            scalePreview: 816 / 377,
        };
    },

    computed: {
        cssProps() {
            return {
                '--x-chip-position': `calc(((100% - ${
                    this.pageWidth / this.scalePreview
                }px)/2) + 16px)`,
            };
        },

        activity() {
            return this.group.activities[0];
        },

        group() {
            return this.element.activity;
        }

    },

    methods: {
        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.activity-email-preview-popup {
    width: 100%;
    height: 100%;
    color: #382153;
}

.activity-email-preview-popup .activity-email-preview-container {
    display: flex;
    flex-direction: column;
    border-radius: 34px;
    padding: 24px 32px;
    width: 100%;
    height: 80vh;
    color: #382153;
    overflow-y: scroll;
    overflow-x: hidden;
    letter-spacing: 0px;
}

.activity-email-preview-popup .activity-email-preview-container::-webkit-scrollbar {
    width: 9px;
    height: 9px;
}

.activity-email-preview-popup .activity-email-preview-container::-webkit-scrollbar-track {
    border-radius: 32px;
}

.activity-email-preview-popup .activity-email-preview-container::-webkit-scrollbar-thumb {
    border-radius: 32px;
    background: rgb(193, 193, 197);
}

.activity-email-preview-popup .activity-email-preview-container .asset-preview-container {
    display: grid;
    column-gap: 20px;
    row-gap: 20px;
    grid-auto-flow: dense;
}

.activity-email-preview-popup .activity-email-preview-container .asset-preview-container .close-btn {
    position: absolute;
    top: 16px;
    right: 12px;
    z-index: 2;
}

.activity-email-preview-popup .activity-email-preview-container .asset-preview-container .close-btn svg {
    width: 10px;
}

.activity-email-preview-popup .activity-email-preview-container .asset-preview-container .close-btn {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.activity-email-preview-popup .activity-email-preview-container .asset-preview-container .close-btn:hover {
    background-color: #f5d5e7;
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .user-email-activity-group .sales-note-details {
    padding: 20px 30px;
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .details, .activity-email-preview-popup .activity-email-preview-container .preview-content-container .user-email-activity-group .sales-note-details {
    background: #fff;
    margin-top: 10px;
    border-radius: 18px;
    position: relative;
    z-index: 100;
    box-shadow: 0 3px 6px rgba(130, 116, 232, 0.1);
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .details .from,
.activity-email-preview-popup .activity-email-preview-container .preview-content-container .details .subject {
    border-bottom: 1px solid #bdbdbd;
    padding: 10px 20px;
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .details .email-label {
    display: inline-block;
    width: 75px;
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .details .message-preview {
    padding-left: 10px;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    overflow: hidden;
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .activities .activity-engagement {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #877d88;
    padding: 30px 18px 5px 18px;
    margin-top: -15px;
    background: #fff;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    -webkit-box-shadow: 0 3px 6px rgba(130, 116, 232, 0.1);
    box-shadow: 0 3px 6px rgba(130, 116, 232, 0.1);
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .open-type img {
    margin-right: 10px;
}

.activity-email-preview-popup .activity-email-preview-container .preview-content-container .click-type img {
    margin-right: 15px;
}

@media (max-width: 850px) {
    .asset-preview-container {
        grid-template-columns: 98%;
        grid-template-areas:
            'preview-asset'
            'information-section';
    }
}

@media (min-width: 850px) {
    .asset-preview-container {
        grid-template-rows: 50px auto;
        grid-template-columns: minmax(auto, 60%) minmax(auto, 40%);
        grid-template-areas:
            'preview-asset information-section'
            'preview-asset information-section';
    }
}
</style>
